<template>
  
  <div :id="_uid" :class="modalClass">
    <div class="ui header">
      Filtrar Laudos
    </div>
    <div class="content">
      <div class="ui form" :class="{ loading }">
        <div class="fields">
          <div :class="{ 'four wide field': $isSimavet(), 'eight wide field': !$isSimavet() }">
            <label class="form-label">Data Inicial</label>
            <date-picker ref="startDatePicker" :autoInit="false" @onChange="onChangeStartDate" />
          </div>         
          <div :class="{ 'four wide field': $isSimavet(), 'eight wide field': !$isSimavet() }">
            <label class="form-label">Data Final</label>
            <date-picker ref="endDatePicker" :autoInit="false" @onChange="onChangeEndDate" />
          </div>                         
          <div v-show="$isSimavet()" class="eight wide field">
            <label class="form-label">Status</label>
            <select-dropdown ref="statusDropdown" @onChange="onChangeStatus" />
          </div>  
        </div>    
        <div v-if="$isSimavet()" class="fields">
          <div class="eight wide field">
            <label class="form-label">Animal</label>
            <input v-model="filter.animalName">
          </div>
          <div class="eight wide field">
            <label class="form-label">Tutor</label>
            <input v-model="filter.ownerName">
          </div>                     
        </div>
        <div v-if="$isSimavet()" class="fields">
          <div class="eight wide field">
            <label class="form-label">Clínica</label>
            <input v-model="filter.customerName">
          </div>
          <div class="eight wide field">
            <label class="form-label">Colaborador</label>
            <input v-model="filter.userName">
          </div>
        </div>
      </div>
    </div>
    <div class="actions">
      <button class="ui cancel basic button">
        <i class="times icon"></i> Sair
      </button>      
      <button v-if="showRemoveButton" class="ui teal basic button" @click="onRemove()">
        <i class="undo icon"></i> Remover
      </button>      
      <button class="ui blue button" @click="onApply()">
        <i class="checkmark icon"></i> Aplicar
      </button>
    </div>
  </div>

</template>

<script>

  import moment from "@/utils/moment"
  import CertService from "@/services/cert-service"
  import modalDialog from "@/mixins/modal-dialog"
  import { DatePicker, SelectDropdown } from "@/components"

  export default {
    
    name: "CertsFilterModal",

    mixins: [modalDialog],

    data() {
      return {
        filter: {},
        showRemoveButton: false,
      }
    },

    components: {
      DatePicker,
      SelectDropdown,
    },

    computed: {      

      modalClass() {

        let str = ""

        if (this.$isSimavet()) {
          str = "ui modal"
        } else {
          str = "ui small modal"
        }

        str += " " + this.modalSelector

        return str
      },
    },

    methods: {      

      onShow() {
        this.emitEvent = null
        this.initFilter()
        this.loadDatePickers()
        this.loadStatusDropdown()
      }, 

      initFilter() {

        if (this.$store.state.pages.filters.certs) {

          this.showRemoveButton = true
          this.filter = this.$cloneObject(this.$store.state.pages.filters.certs)

        } else {          

          this.showRemoveButton = false
          this.filter = { startDate: null, endDate: null, status: "*" }
        }        
      },

      loadDatePickers() {
        
        this.$refs.startDatePicker.initCalendar({ force: true })
        this.$refs.endDatePicker.initCalendar({ force: true })

        if (this.filter.startDate && this.filter.endDate) {
          this.$refs.startDatePicker.setDate(this.filter.startDate)
          this.$refs.endDatePicker.setDate(this.filter.endDate)
        }        
      },

      loadStatusDropdown() {
        
        let statusList = [{ id: "*", value: '<i class="asterisk icon"></i> Todos' }]        
        const CERT_STATUS = CertService.STATUS

        for (let prop in CERT_STATUS) {
          if (CERT_STATUS.hasOwnProperty(prop)) {
            statusList.push({
              id: prop,
              value: `<i class="${CERT_STATUS[prop].icon}"></i> ` + CERT_STATUS[prop].description
            })
          }
        }

        this.$refs.statusDropdown.setValues(statusList, this.filter.status)
      },      


      onChangeStartDate(date) {
        this.filter.startDate = date
        this.refreshData()          
      },

      onChangeEndDate(date) {
        this.filter.endDate = date
        this.refreshData()          
      },

      onChangeStatus(status) {
        this.filter.status = status
        this.refreshData()
      },

      refreshData() {
        this.filter = this.$cloneObject(this.filter)
      },

      onApply() {

        if (!this.validDates())
          return

        this.updateStore(this.filter)

        let data = this.$cloneObject(this.filter)
        
        if (data.startDate && data.endDate) {
          data.startDate = moment(data.startDate).format("YYYY-MM-DD")
          data.endDate = moment(data.endDate).format("YYYY-MM-DD")
        }        
        
        this.emitEvent = { event: "onApply", data }

        this.hide()        
      },

      validDates() {

        let isOk = true
        let message = ""

        if (this.filter.startDate && !this.filter.endDate) {
          message = "Informe a data final"
        } else if (this.filter.endDate && !this.filter.startDate) {
          message = "Informe a data inicial"            
        } 

        if (message) {
          isOk = false
          this.$msg.info(message)
        }

        return isOk
      },

      updateStore(filter) {

        let filters = this.$cloneObject(this.$store.state.pages.filters)

        filters.certs = filter ? this.$cloneObject(filter) : null

        this.$store.commit("pages/setFilters", filters)
      },

      onRemove() {

        this.clear()

        this.$refs.startDatePicker.clearDate()
        this.$refs.endDatePicker.clearDate()

        this.emitEvent = { event: "onRemove" }

        this.hide()      
      },

      clear() {
        this.updateStore(null)
      },
    },
  }

</script>